import React, { useEffect, useRef, useState } from 'react';
import createCommentsManager from '../Ads/managers/CommentAdManager';
import AdUnit from '../Ads/AdUnit';
import { getUserGeoCountry } from '@buzzfeed/bf-utils/lib/localization';

const withAds = Component => {
  return function ComponentWithAds(props) {
    const { buzz } = props;
    const adPlacer = useRef(null);
    const [adPlaceholders, setAdPlaceholders] = useState(null);
    const onAdPlaceholderRefsReady = (placeholders) => {
      const isDifferent = 
        !adPlaceholders || 
        placeholders.length !== adPlaceholders.length || 
        placeholders.some((placeholder, index) => !placeholder.isSameNode(adPlaceholders[index]));

      if (isDifferent) {
        setAdPlaceholders([...placeholders]);
      }
    };
    const [adPortals, setAdPortals] = useState([]);
    const containerRef = useRef(null);
    const isEligible = buzz?.classification?.section !== 'Discussion' &&
        buzz?.classification?.section !== 'Make Yours' &&
        !['gb', 'ie', 'uk', 'nz', 'au'].includes(getUserGeoCountry().toLowerCase()) &&
        buzz?.classification?.edition !== 'Japan';

    useEffect(() => {
      if (!isEligible) {
        return () => {};
      }

      if (!adPlaceholders) {
        return () => {};
      }
  
      if (adPlacer.current) {
        adPlacer.current.destroy();
      }
  
      setAdPortals([]);
      adPlacer.current = createCommentsManager({
        AdUnit,
        element: containerRef.current,
        onAdsReady: (portals) => {
          setAdPortals(portals);
        },
        pixiedust: {}, // TODO
        placeholders: adPlaceholders,
        language: buzz.language
      });
      adPlacer.current.init();
  
      return () => {
        if (adPlacer.current) {
          adPlacer.current.destroy();
        }
      };
    }, [adPlaceholders]);

    return (
      <div ref={containerRef}>
        {adPortals.map((AdPortal, idx) => (
          <AdPortal key={idx} />
        ))}
        <Component
          {...props}
          isAdsInComments={isEligible}
          onAdPlaceholderRefsReady={onAdPlaceholderRefsReady}
        />
      </div>
    );
  }
};

export default withAds;